import { createPaginatedKey } from "api/keys";

export const messagesKeys = {
  smsMessages: createPaginatedKey("smsMessages"),
  emailMessages: createPaginatedKey("emailMessages"),
};
